import {
    DEALERSAMPLEFILE_SUCCESS,
    DEALERSAMPLEFILE_FAILED,
    RESET_DEALERSAMPLEFILE,
    LOADING_DEALERSAMPLEFILE,
    NETWORK_ERROR_DEALERSAMPLEFILE
} from '../types/index'

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
}

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_DEALERSAMPLEFILE:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case DEALERSAMPLEFILE_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case DEALERSAMPLEFILE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_DEALERSAMPLEFILE:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_DEALERSAMPLEFILE:
            return (state = initialState);
        default:
            return state;
    }
};